export default "__VITE_ASSET__DinbB221__"